"use client";

import { useTranslations } from "next-intl";

import { useRouter } from "@/i18n/routing";
import Button from "@/ui/Button";
import { CardLayouts } from "@/ui/Common/CardLayouts";
import { cn } from "@/utils/cn";

import styles from "./styles.module.scss";

interface ObjectDetailLayoutsProps {
  layouts: any[];
  className?: string;
  slug: string;
}

export function ObjectDetailLayouts({
  layouts,
  className,
  slug,
}: ObjectDetailLayoutsProps) {
  const t = useTranslations();
  const router = useRouter();

  if (!layouts?.length) {
    return null;
  }

  const plansUrl = `/developers/${slug}/plans/`;

  return (
    <section className={cn("mb-[3rem]", className)}>
      <h2 className={"object-detail__section-header mb-[3rem]"}>
        {t("Plans")}
      </h2>
      <div className={styles.layoutsContainer}>
        {layouts.map((item: any, index: number) => (
          <CardLayouts
            key={item.id || `layout-${index}`}
            rooms={item.rooms}
            area={item.area}
            convertedPrices={item.convertedPrices}
            convertedPricesPerSqM={item.convertedPricesPerSqM}
            images={item.images}
            type={item.type}
            slug={slug}
          />
        ))}
      </div>
      <div className="flex mt-[4rem] xl:mt-[5rem]">
        <Button
          className="w-full max-w-[25rem] m-auto"
          color="red"
          onClick={() => router.push(plansUrl)}
        >
          {t("See all")}
        </Button>
      </div>
    </section>
  );
}
